import FarmacloudCodeAuth from './FarmacloudCodeAuth'
export default FarmacloudCodeAuth
